<template>
    <div>
        <top-navbar></top-navbar>
<div>
 

<div class="container-fluid">
  <h6 class="manage-boder pt-2 font1 font-bold1"> <a class="decoration" to="/"> Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Product Sales </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Product  GIN </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/gin/index"> Manage GIN </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Create GIN  </h6>
  <h6 class="custom-maintitle mb-2"><b>Create GIN</b></h6>
<div class="card ">
<div class="card-body">
  <form @submit.prevent="SaveGin()" >

<div class="row">
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Issued to </label>
            <input v-model="gin.end_user"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Issue Date </label>
            <input type="date" v-model="gin.issues_date"  style="font-size: small;" class="form-control" required>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Remarks </label>
            <textarea v-model="gin.SI_remarks" style="font-size: small;" class="form-control" rows="3"></textarea>
    </div>
  </div>
</div>



    <h6 class="purchitem mb-2"><b>GIN Items</b></h6>
    <div class="table-responsive">
      <table style="font-size: small; " class="table table-striped table-sm table-hover ">
        <thead class="background_color2">
          <tr class="custom-label2">
           
                <th>   
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Product Code</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Available Qty</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> GIN Qty</label>
                  </div>
                </th>
               
                
              
                <th></th>  
            </tr>
          </thead>
          <tbody>
            <tr>
             
              <td>
                <input class="form-control" style="font-size: small;" placeholder="Select Product" v-model="detail[0].P_code" list="products" @input="loadProductId(0)"  required>
                    <datalist id="products" >
                       
                        <option v-for="product in products" :key="product.id" >
                            {{ product.P_code }} 
                        </option>
                        
                  
                    </datalist>  
                    <input v-model="detail[0].inven_id"  hidden  required>
              </td>
              <td><input type="number" v-model="detail[0].available_qty" style="font-size: small;" class="form-control" disabled required></td>
              <td><input type="number" v-model="detail[0].SD_qty" style="font-size: small;" class="form-control" required></td>
             
              <td class="custom-icon">  <b-icon @click="add" class="ms-2 mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
              
            </tr>
            <tr v-for="key in count" :key="key">
           
              <td>
                <input class="form-control" style="font-size: small;" placeholder="Select Product" v-model="detail[key].P_code" list="products" @input="loadProductId(key)"  required>
                    <datalist id="products" >
                       
                        <option v-for="product in products" :key="product.id" >
                            {{ product.P_code }}
                        </option>
                        
                       
                    </datalist> 
                    <input v-model="detail[key].inven_id" hidden required>
              </td>
              <td><input type="number" v-model="detail[key].available_qty" style="font-size: small;" class="form-control" disabled required></td>
              <td><input type="number" v-model="detail[key].SD_qty" style="font-size: small;" class="form-control" required></td>
             
              <td class="custom-icon"> 
                <b-icon @click="remove" class="ms-2 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon>
                 <b-icon @click="add" class="ms-3 mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon>
                 </td>
              
            </tr>



          
            
          </tbody>


        </table>
       
    </div>

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
      <button  type="submit" class="mr-1 btn custom-btn btn-primary  mb-1 font-size_def bdr-rad">Create</button>
    </div>
    </div>



</form>
</div>
</div>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        count: 0,
        gin:{},
        products:[],
        detail:[
                {
                available_qty:'',
                inven_id:'',           
                },
               ],
      


        
      }

    },
    mounted(){
 
  this.loadProduct();
    },
methods : {

  async SaveGin() {
    
    console.log(this.gin);
    console.log(this.detail);
    try {
      const { data} = await  axios.post('/istockissue/create',{userid:this.userid,cont:this.count,gin:this.gin,detail:this.detail},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.status = data.status;
       if(this.status == 200){
        this.$router.push('/gin/index');
       }
      
    } catch (error) {
      console.log(error.response);
    }
  },

        async loadProductId(id){
                console.log("amila");
               
                try {
          const { data} = await  axios.post('/istockissue/loadid',{product:this.detail[id].P_code},{
            headers:{
              'Authorization':'Bearer '+this.access_token,
              'Content-type': 'application/json',
             
            }
           });
           console.log(data);
           this.detail[id].available_qty= data.rem_qty;
           this.detail[id].inven_id= data.inv_id;
           
           
          
          
        } catch (error) {
          console.log(error.response);
        }
             
      },



  
  async loadProduct() {
    console.log(this.access_token);
    try {
      const { data} = await  axios.get('/istockissue/loadprodcut',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.products = data.product;
      
    } catch (error) {
      console.log(error.response);
    }
  },

  add: function(){
            this.count++;
            this.detail.push({
                available_qty:'',
                inven_id:'',   
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
                available_qty:'',
                inven_id:'',   
            },1)
            
        },


},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style scoped>

</style>